import {makeStyles} from "@material-ui/core"

// Theme
import {ModernTheme} from "../../../../../theme/modern/tokens"

export default makeStyles((theme: ModernTheme) => ({
    /**
     * Anchored to the field's own wrapper rather than the page, so it moves
     * with the card in both the top-strip and the sidebar-dock arrangements.
     */
    list: {
        position: "absolute",
        left: 0,
        right: 0,
        top: "100%",
        zIndex: 30,
        margin: "4px 0 0",
        padding: 4,
        listStyle: "none",
        maxHeight: 248,
        overflowY: "auto",
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 8,
        boxShadow: theme.modern.shadow,
    },
    item: {
        display: "flex",
        alignItems: "baseline",
        // the lead pill follows the statement instead of being pushed to the
        // far edge, so it reads as part of the sentence it belongs to
        justifyContent: "flex-start",
        flexWrap: "wrap",
        gap: "6px",
        padding: "7px 10px",
        borderRadius: 5,
        cursor: "pointer",
        font: `400 14px/1.35 ${theme.modern.sans}`,
        color: theme.modern.ink2,
    },
    /**
     * Highlight follows the keyboard, so it has to read as "this is what Enter
     * does" rather than as hover decoration — hence the accent fill rather than
     * a faint tint.
     */
    item__active: {
        background: theme.modern.accentSoft,
        color: theme.modern.ink,
    },
    text: {
        minWidth: 0,
    },
    /**
     * A pill, not a caption.
     *
     * A grey note at the end of the row was read as decoration; an accent pill
     * beside the statement reads as "choosing this gives you the lead picker",
     * which is what it means.
     */
    leads: {
        flex: "none",
        font: `600 10.5px/1 ${theme.modern.sans}`,
        letterSpacing: ".06em",
        textTransform: "uppercase",
        color: theme.modern.accent,
        background: theme.modern.accentSoft,
        border: `1px solid ${theme.modern.accentLine}`,
        borderRadius: 99,
        padding: "3px 8px",
        cursor: "pointer",
    },
}))
